<template>
  <nav
    v-if="pageCount > 1"
    class="pagination is-centered is-small"
    role="navigation"
    aria-label="pagination"
  >
    <a
      class="pagination-previous"
      :disabled="firstPageSelected"
      @click.prevent="prevPage()"
      @keyup.enter="prevPage()"
    >
      <i class="fas fa-chevron-left"></i>
    </a>
    <ul class="pagination-list">
      <li v-for="page in pages" :key="page.index">
        <span v-if="page.disabled">{{ page.content }}</span>
        <a
          v-else
          class="pagination-link"
          @click="handlePageSelected(page.index)"
          @keyup.enter="handlePageSelected(page.index)"
          :class="{ 'is-current': page.selected }"
          >{{ page.content }}</a
        >
      </li>
    </ul>
    <a
      class="pagination-next"
      :disabled="lastPageSelected"
      @click.prevent="nextPage()"
      @keyup.enter="nextPage()"
    >
      <i class="fas fa-chevron-right"></i>
    </a>
  </nav>
</template>

<script>
import paginationUtil from "@/util/pagination";

export default {
  props: {
    itemsCount: {
      type: Number,
      required: true
    },
    currentPage: {
      type: Number,
      default: 0
    },
    pageRange: {
      type: Number,
      default: 3
    },
    marginPages: {
      type: Number,
      default: 1
    },
    perPage: {
      type: Number,
      default: 15
    }
  },
  data() {
    return {
      direction: ""
    };
  },
  watch: {
    pageCount(newCount) {
      if (newCount === 0 || newCount < this.currentPage) {
        this.reset();
      }
    }
  },
  computed: {
    lastPage() {
      return Math.ceil(this.itemsCount / this.perPage) - 1;
    },
    pageCount() {
      return this.lastPage + 1;
    },
    pages() {
      return paginationUtil.getPages(
        this.currentPage,
        this.pageCount,
        this.pageRange,
        this.marginPages
      );
    },
    firstPageSelected() {
      return this.currentPage === 0;
    },
    lastPageSelected() {
      return this.currentPage === this.pageCount - 1 || this.pageCount === 0;
    }
  },
  methods: {
    changePage(newPageIndex) {
      this.$emit("page-change", {
        currentPage: parseInt(newPageIndex),
        direction
      });

      let direction = newPageIndex > this.currentPage ? "next" : "prev";

      this.direction = direction;
    },
    nextPage() {
      if (this.currentPage !== this.lastPage) {
        this.changePage(this.currentPage + 1);
      }
    },
    prevPage() {
      if (this.currentPage > 0) {
        this.changePage(this.currentPage - 1);
      }
    },
    reset() {
      this.changePage(0);
    },
    handlePageSelected(selected) {
      if (this.currentPage === selected) return;

      this.changePage(selected);
    }
  }
};
</script>

<style lang="css" scoped>
a {
  cursor: pointer;
  text-decoration: none;
}

ul li {
  list-style: none;
}
</style>
